// Custom Error Messages for different interactions

export const ERROR_MESSAGES = {
  EMPTY_RESPONSE: "Please enter a response before submitting",

  // Re-usable Function for Displaying different character lengths
  CHARACTER_LIMIT_REACHED: (limit: number) =>
    `Character limit reached (${limit} characters maximum)`
}
